import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { AsideDefault } from './components/aside/AsideDefault'
import { Footer } from './components/Footer'
import { HeaderWrapper } from './components/header/HeaderWrapper'
import { ScrollTop } from './components/ScrollTop'
import { Content } from './components/Content'
import { PageDataProvider } from './core'
import { useLocation } from 'react-router-dom'
import { MenuComponent } from '../assets/ts/components'
import { InactivityProvider } from '../../app/modules/auth/inatividade/InactivityContext'
import { SessionInactivityManager } from '../../app/modules/auth/inatividade/SessionInactivityManager'
import { NotificacoesProvider } from '../../app/modules/apps/notificacoes/core/NotificacoesProvider'
import styles from './MasterLayout.module.css'
import { SupportTab } from '../../app/components/Support/SupportTab'

const MasterLayout = () => {
  const location = useLocation()
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  return (
    <InactivityProvider>
      <NotificacoesProvider>
        <PageDataProvider>
          <div className='page d-flex flex-row flex-column-fluid'>
            <AsideDefault />
            <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
              <HeaderWrapper />

              <div
                id='kt_content'
                className={`content d-flex flex-column flex-column-fluid ${styles.content}`}
              >
                <div className='post d-flex flex-column-fluid' id='kt_post'>
                  <Content>
                    <Outlet />
                  </Content>
                </div>
              </div>
              <Footer />
            </div>
          </div>

          <ScrollTop />
          <SupportTab />
          <SessionInactivityManager />
        </PageDataProvider>
      </NotificacoesProvider>
    </InactivityProvider>
  )
}

export { MasterLayout }
